import { Card, Col, Row } from "antd";

import styles from "../index.module.less";
import ParkingOccupancyPieChart from "./ParkingOccupancyPieChart";
import { General } from "../../../util/General";
import Loading from "../../common/Loading";

import type { ParkingOccupancyData } from "../../../shared/interface/dashboard.interface";

interface ParkingOccupancyStatusCardProps {
  data: ParkingOccupancyData;
  loading: boolean;
  isFullScreen?: boolean;
}

const ParkingOccupancyStatusCard = (props: ParkingOccupancyStatusCardProps) => {
  const pieChartData = [
    { name: "Parked", value: props?.data?.total_parked_slots || 0 },
    { name: "Empty", value: props?.data?.total_empty_slots || 0 },
    { name: "Dead", value: props?.data?.total_dead_slots || 0 },
    { name: "Queue", value: props?.data?.total_booked_slots || 0 }
  ];

  const hasData = pieChartData?.some((item) => item?.value !== null && item?.value !== 0);

  const styleLabel = props?.isFullScreen ? styles["label-full-screen"] : styles["label"];
  const styleCount = props?.isFullScreen ? styles["count-full-screen"] : styles["count"];

  const renderUI = () => (
    <>
      <div className={props?.isFullScreen ? styles["card-header-full-screen"] : styles["card-header"]}>{"Parking Occupancy Status"}</div>
      {props.loading ? (
        <Loading />
      ) : !props.loading && props?.data && hasData ? (
        <Row gutter={[16, 16]} className={props?.isFullScreen ? styles["parking-status-container-full-screen"] : styles["parking-status-container"]}>
          <Col span={13} className={styles["parking-status-container-col1"]}>
            {hasData ? <ParkingOccupancyPieChart data={pieChartData} /> : "No data available!"}
          </Col>

          <Col span={11} className={styles["parking-status-container-col2"]}>
            <div className={`${styles["status-count-container"]} `}>
              <div className={styles["status-container"]}>
                <div className={styles["parked-status-bgcolor"]}></div>
                <span className={styleLabel}>{pieChartData[0].name}</span>
              </div>
              <span className={styleCount}>{General.numberWithCommas(props?.data?.total_parked_slots ?? 0)}</span>
            </div>
            <div className={`${styles["status-count-container"]} ${styles["border-status-box2"]}`}>
              <div className={styles["status-container"]}>
                <span className={styles["empty-status-bgcolor"]}></span>
                <span className={styleLabel}>{pieChartData[1].name}</span>
              </div>
              <span className={styleCount}>{General.numberWithCommas(props?.data?.total_empty_slots ?? 0)}</span>
            </div>
            <div className={`${styles["status-count-container"]} ${styles["border-status-box3"]}`}>
              <div className={styles["status-container"]}>
                <span className={styles["dead-status-bgcolor"]}></span>
                <span className={styleLabel}>{pieChartData[2].name}</span>
              </div>
              <span className={styleCount}>{General.numberWithCommas(props?.data?.total_dead_slots ?? 0)}</span>
            </div>
            <div className={`${styles["status-count-container"]} ${styles["border-status-box3"]}`}>
              <div className={styles["status-container"]}>
                <span className={styles["booked-status-bgcolor"]}></span>
                <span className={styleLabel}>{pieChartData[3].name}</span>
              </div>
              <span className={styleCount}>{General.numberWithCommas(props?.data?.total_booked_slots ?? 0)}</span>
            </div>
            <div className={`${styles["status-count-container"]} `}>
              <div className={styles["status-container"]}>
                <span className={styles["total-status-bgcolor"]}></span>
                <span className={styleLabel}>Total</span>
              </div>
              <span className={styleCount}>{General.numberWithCommas(props?.data?.total_parking_slots ?? 0)}</span>
            </div>
          </Col>
        </Row>
      ) : (
        <div className={styles["parking-card-section"]}>
          <svg width="100%">
            <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="h3">
              No data available!
            </text>
          </svg>
        </div>
      )}
    </>
  );
  return props?.isFullScreen ? (
    <div className="gx-text-center gx-p-2">{renderUI()}</div>
  ) : (
    <Card title={null} bodyStyle={{ padding: "15px" }} className={`gx-card gx-text-center ${styles["card-container"]}`}>
      {renderUI()}
    </Card>
  );
};

export default ParkingOccupancyStatusCard;
